
// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { useConfig } from '../context/ConfigContext'; // Import useConfig hook
import axios from "../utils/axiosHandler";

const ForgotPassword = () => {
  const [identifier, setIdentifier] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const { config } = useConfig(); // Get config from context

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const { data } = await axios.post('/api/forgot-password', { identifier });
      setMessage(data.message);
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="p-14" >
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8" style={{ marginTop: '100px', marginBottom: '70px' }}>
        <h2 className="text-2xl font-bold mb-4" style={{ color: config.colors.textPrimary }}>Forgot Password</h2>
        {message && <p style={{ color: config.colors.secondary, marginBottom: '1rem' }}>{message}</p>}
        {error && <p style={{ color: '#ef4444', marginBottom: '1rem' }}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2" style={{ color: config.colors.textPrimary }}>Email or Phone Number</label>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="w-full px-3 py-2 border rounded"
              style={{
                borderColor: `${config.colors.textSecondary}40`,
                outlineColor: config.colors.primary
              }}
              placeholder="Enter your email or phone number"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 rounded text-white"
            style={{
              backgroundColor: config.colors.primary,
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = `${config.colors.primary}DD`;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = config.colors.primary;
            }}
          >
            Send Reset Link
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;




// // before configcoloring
// // src/pages/ForgotPassword.js
// import React, { useState } from 'react';

// const ForgotPassword = () => {
//   const [identifier, setIdentifier] = useState("");
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setMessage("");
//     try {
//       const { data } = await axios.post('/api/forgot-password', { identifier });
//       setMessage(data.message);
//     } catch (err) {
//       setError("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <div className="p-14" >
//       <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8" style={{ marginTop: '100px', marginBottom: '70px' }}>
//         <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
//         {message && <p className="text-green-500 mb-4">{message}</p>}
//         {error && <p className="text-red-500 mb-4">{error}</p>}
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-gray-700 mb-2">Email or Phone Number</label>
//             <input
//               type="text"
//               value={identifier}
//               onChange={(e) => setIdentifier(e.target.value)}
//               className="w-full px-3 py-2 border rounded"
//               placeholder="Enter your email or phone number"
//               required
//             />
//           </div>
//           <button type="submit" className="w-full bg-blue-500 text-white px-4 py-2 rounded">
//             Send Reset Link
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
